// extracted by mini-css-extract-plugin
export default {"l":"_51d2fa465c"};